import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import Icons from respective packages
import {
  faHouse,
  faEllipsis,
  faChevronDown,
  faChevronUp,
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faCheck,
  faXmark as faXmarkSolid,
  faLock,
  faMicrophone,
  faCamera,
  faEllipsisVertical as faEllipsisVerticalSolid,
  faPersonRunning,
  faRecordVinyl,
  faArrowRotateLeft,
  faStopCircle,
  faWrench,
  faPaperPlane,
  faVideoCamera,
  faChalkboardUser,
  faRotateLeft as faRotateLeftSolid,
  faRotateRight as faRotateRightSolid,
  faHeading,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faCode as faCodeSolid,
  faLink as faLinkSolid,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faFlag,
  faArrowDown19,
  faArrowUpShortWide,
  faArrowDownWideShort,
} from '@fortawesome/free-solid-svg-icons'
import {
  faXmark as faXmarkRegular,
  faScaleUnbalanced,
  faList,
  faTrashCan,
  faCircleCheck,
  faCircleXmark,
  faClone,
  faPen,
  faCircleExclamation,
  faCircleEllipsis,
  faRotateRight,
  faMinus,
  faMagnifyingGlass,
  faLayerGroup,
  faPercent,
  faPlus,
  faPlayCircle,
  faCircleInfo,
  faHand,
  faCodeBranch,
  faFileImage,
  faFileAudio,
  faFileVideo,
  faFilePdf,
  faFileZip,
  faFileWord,
  faFileSpreadsheet,
  faFilePowerpoint,
  faFileLines,
  faFile,
  faMessage,
  faPaperclip,
  faPaperPlaneTop,
  faBoxArchive,
  faArrowRight as faArrowRightRegular,
  faClockThree,
  faCircleQuestion,
  faPenToSquare,
  faComments,
  faFiles,
  faBookmark,
  faEllipsisVertical,
  faPersonWalkingArrowRight,
  faPaintRoller,
  faEye,
  faEyeSlash,
  faGear,
  faArrowRightFromBracket,
  faArrowsRepeat,
  faGearComplexCode,
  faEnvelope,
  faCommentDots,
  faLink,
  faHandshakeAngle as faHandshakeAngleRegular,
  faCheck as faCheckRegular,
  faFileExport,
  faWifiSlash,
  faFloppyDisk,
  faPenLine,
  faDownload,
  faIslandTropical as faIslandTropicalRegular,
  faArrowTurnDownLeft,
  faUser as faUserRegular,
  faUserSlash,
  faUserMinus,
  faClipboardListCheck,
  faArrowUpRightFromSquare,
  faArrowUpRight,
  faCode,
  faWindowMaximize,
  faCirclePlay,
  faSubtitles,
  faUpload,
  faArrowRightToBracket,
  faBallotCheck,
  faCirclesOverlap as faCirclesOverlapRegular,
  faFilter,
  faCircleMinus,
  faArrowsRotate,
  faArrowsRotateReverse,
  faUserPlus,
  faRefresh,
  faLock as faLockRegular,
  faLockOpen as faLockOpenRegular,
  // NIC NEW ICONS ADDED HERE
  faChartTreeMap,
  faBuilding,
  faFilm,
  faFlaskVial,
  faFlask,
  faTableList,
  faSolarSystem,
  faCirclesOverlap,
  faVial,
  faSquarePlus,
  faBookSparkles,
  faBinoculars,
  faShare,
  faCube,
  faFrame,
  faIcons,
  faCodeFork,
  faCodeSimple,
  faSquareCode,
  faPersonDotsFromLine,
  faSquareCheck,
  faArrowRightLong,
  faDiagramVenn,
  faGraduationCap,
  faGrid,
  faPerson,
  faGripDotsVertical as faGripDotsVerticalRegular,
  faTableLayout,
  faSquareLeft,
  faArrowLeft as faArrowLeftRegular,
  faMapPin,
  faPalette,
  faChartPieSimple,
  faRotateLeft,
  faPhone,
  faComment,
  faMars,
  faVenus,
  faScroll,
  faFileArrowUp,
  faVideo,
  faMicrophone as faMicrophoneRegular,
  faCommentQuote,
  faLanguage,
  faVenusMars,
  faPlay,
  faCircle,
  faArrowDownToBracket,
  faImage,
  faCompassDrafting,
  faChevronRight as faChevronRightRegular,
  faChevronLeft as faChevronLeftRegular,
  faPaintbrush,
  faPhotoFilmMusic,
  faSwap as faSwapRegular,
  faVolume,
  faHouse as faHouseRegular,
  faWandMagicSparkles,
  faCopy,
  faFileImport,
  faLaptop,
  faCloud,
  faLightbulb,
  faReceipt,
  faPartyHorn,
  faPlug,
  faUsers as faUsersRegular,
  faUserGroup,
  faShield,
  faArrowUpArrowDown,
  faArrowRightArrowLeft,
  faArrowTrendUp,
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faArrowRotateLeft as faArrowRotateLeftRegular,
  faArrowUpFromBracket,
  faClockRotateLeft,
  faSliders,
  faSpinnerThird,
  faTriangleExclamation,
  faQuoteLeft,
  faCheckDouble,
  faListCheck,
  faCrown,
  faUserShield,
  faUserPen,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faGripDotsVertical,
  faChevronLeft,
  faChevronRight,
  faMessages,
  faArrowLeft,
  faArrowRight,
  faInbox,
  faReply,
  faUser,
  faUsers,
  faTriangle,
  faScreencast,
  faPhoneHangup,
  faIslandTropical,
  faSquareCheck as faSquareCheckSolid,
  faHandshakeAngle,
  faFile as faFileSolid,
  faSquareCode as faSquareCodeSolid,
  faTags,
  faVial as faVialSolid,
  faFlaskVial as faFlaskVialSolid,
  faTable,
  faCaretRight,
  faBookSparkles as faBookSparklesSolid,
  faCirclesOverlap as faCirclesOverlapSolid,
  faPen as faPenSolid,
  faClipboardListCheck as faClipboardListCheckSolid,
  faExclamationCircle,
  faGrid as faGridSolid,
  faList as faListSolid,
  faListOl as faListOlSolid,
  faHeadSide,
  faPlus as faPlusSolid,
  faMinus as faMinusSolid,
  faCircleCheck as faCircleCheckSolid,
  faCircleXmark as faCircleXmarkSolid,
  faUpload as faUploadSolid,
  faPlay as faPlaySolid,
  faSparkles,
  faBlockQuote,
  faExclamation,
  faBars,
  faAsterisk,
  faSwap,
  faCirclePlay as faCirclePlaySolid,
  faSpinner,
  faCirclePlus as faCirclePlusSolid,
  faArrowDown as faArrowDownSolid,
  faArrowUp as faArrowUpSolid,
  faShuffle as faShuffleSolid,
  faTriangleExclamation as faTriangleExclamationSolid,
  faCircleExclamation as faCircleExclamationSolid,
  faCircle as faCircleSolid,
} from '@fortawesome/pro-solid-svg-icons'

// Add Icons to library for access in other components
library.add(
  faHouse,
  faXmarkSolid,
  faXmarkRegular,
  faScaleUnbalanced,
  faList,
  faPen,
  faEllipsis,
  faPlus,
  faTrashCan,
  faGripDotsVertical,
  faCircleCheck,
  faCircleXmark,
  faClone,
  faChevronDown,
  faChevronUp,
  faCircleExclamation,
  faRotateRight,
  faMinus,
  faCircleEllipsis,
  faCheck,
  faMagnifyingGlass,
  faLayerGroup,
  faPercent,
  faPlayCircle,
  faCircleInfo,
  faChevronLeft,
  faChevronRight,
  faLock,
  faMicrophone,
  faMicrophoneRegular,
  faCamera,
  faHand,
  faScreencast,
  faPhoneHangup,
  faEllipsisVertical,
  faCodeBranch,
  faFileImage,
  faFileAudio,
  faFileVideo,
  faFilePdf,
  faFileZip,
  faFileWord,
  faFileSpreadsheet,
  faFilePowerpoint,
  faFileLines,
  faFile,
  faChevronLeft,
  faChevronRight,
  faLock,
  faMessage,
  faMessages,
  faArrowLeft,
  faPaperclip,
  faPaperPlaneTop,
  faInbox,
  faBoxArchive,
  faReply,
  faUser,
  faUsers,
  faArrowRightRegular,
  faClockThree,
  faCircleQuestion,
  faPenToSquare,
  faComments,
  faFiles,
  faBookmark,
  faEllipsisVertical,
  faTriangle,
  faPersonWalkingArrowRight,
  faChevronLeftSolid,
  faChevronRightSolid,
  faEllipsisVerticalSolid,
  faPaintRoller,
  faIslandTropical,
  faHandshakeAngle,
  faFileSolid,
  faSquareCode,
  faEye,
  faArrowRightFromBracket,
  faPersonRunning,
  faTags,
  faVial,
  faFlaskVial,
  faFlask,
  faTable,
  faCaretRight,
  faArrowsRepeat,
  faGearComplexCode,
  faBookSparkles,
  faEnvelope,
  faCommentDots,
  faLink,
  faEyeSlash,
  faHandshakeAngleRegular,
  faCheckRegular,
  faFileExport,
  faWifiSlash,
  faCirclesOverlap,
  faFloppyDisk,
  faPenLine,
  faDownload,
  faIslandTropicalRegular,
  faArrowTurnDownLeft,
  faUserRegular,
  faUserSlash,
  faUserMinus,
  faClipboardListCheck,
  faPenSolid,
  faClipboardListCheckSolid,
  faArrowUpRightFromSquare,
  faCode,
  faWindowMaximize,
  faCirclePlay,
  faSubtitles,
  faUpload,
  faArrowRight,
  faBallotCheck,
  faArrowRightToBracket,
  faCirclesOverlapRegular,
  faFilter,
  faCircleMinus,
  faArrowsRotate,
  faArrowsRotateReverse,
  faUserPlus,
  faRefresh,
  faLockRegular,
  faLockOpenRegular,
  faSquareCodeSolid,
  faVialSolid,
  faFlaskVialSolid,
  faBookSparklesSolid,
  faCirclesOverlapSolid,
  faLayerGroup,
  faCodeBranch,
  faFileLines,
  // NIC NEW ICONS ADDED HERE
  faChartTreeMap,
  faBuilding,
  faFilm,
  faChartTreeMap,
  faBuilding,
  faFilm,
  faPersonDotsFromLine,
  faFlaskVial,
  faTableList,
  faSolarSystem,
  faLayerGroup,
  faCirclesOverlap,
  faVial,
  faPenToSquare,
  faFileLines,
  faSquarePlus,
  faBookSparkles,
  faBinoculars,
  faShare,
  faCodeBranch,
  faCube,
  faFrame,
  faGear,
  faIcons,
  faCodeFork,
  faCodeSimple,
  faSquareCode,
  faSquareCheck,
  faSquareCheckSolid,
  faArrowLeftRegular,
  faArrowRightLong,
  faDiagramVenn,
  faLayerGroup,
  faGraduationCap,
  faGrid,
  faPerson,
  faListSolid,
  faListOlSolid,
  faExclamationCircle,
  faGridSolid,
  faGripDotsVerticalRegular,
  faTableLayout,
  faSquareLeft,
  faMapPin,
  faPalette,
  faChartPieSimple,
  faRotateLeft,
  faRecordVinyl,
  faArrowRotateLeft,
  faStopCircle,
  faWrench,
  faPaperPlane,
  faVideoCamera,
  faPhone,
  faComment,
  faMars,
  faVenus,
  faScroll,
  faFileArrowUp,
  faVideo,
  faCommentQuote,
  faLanguage,
  faVenusMars,
  faChalkboardUser,
  faPlay,
  faHeadSide,
  faPlusSolid,
  faMinusSolid,
  faCircleCheckSolid,
  faCircle,
  faArrowDownToBracket,
  faCircleXmarkSolid,
  faCircleSolid,
  faUploadSolid,
  faPlaySolid,
  faImage,
  faArrowUpRight,
  faSparkles,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faCodeSolid,
  faLinkSolid,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faRotateLeftSolid,
  faRotateRightSolid,
  faHeading,
  faBlockQuote,
  faCompassDrafting,
  faChevronRightRegular,
  faChevronLeftRegular,
  faExclamation,
  faBars,
  faAsterisk,
  faPaintbrush,
  faSwap,
  faPhotoFilmMusic,
  faSwapRegular,
  faVolume,
  faCirclePlaySolid,
  faHouseRegular,
  faWandMagicSparkles,
  faSpinner,
  faCircleExclamationSolid,
  faCheckDouble,
  faListCheck,
  faCopy,
  faFileImport,
  faLightbulb,
  faFlag,
  faLaptop,
  faCloud,
  faReceipt,
  faPartyHorn,
  faArrowDown19,
  faArrowUpShortWide,
  faArrowDownWideShort,
  faCirclePlusSolid,
  faPlug,
  faUsersRegular,
  faUserGroup,
  faShield,
  faArrowUpArrowDown,
  faArrowRightArrowLeft,
  faArrowTrendUp,
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faUserSlash,
  faArrowRotateLeftRegular,
)

// Test editor › Sample scripts (sample grading).
library.add(
  faArrowUpFromBracket,
  faClockRotateLeft,
  faSliders,
  faCrown,
  faUserShield,
  faUserPen,
  faSpinnerThird,
  faTriangleExclamation,
  faQuoteLeft,
  faArrowDownSolid,
  faArrowUpSolid,
  faShuffleSolid,
  faTriangleExclamationSolid,
)

// setup nuxt plugin
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('FontAwesomeIcon', FontAwesomeIcon)
})
